<p
  i18n="
    @@seo_detail_si_estas_planificando_viajar_a_x_reserva_ahora_tu_habitacion_en_el_alojamiento_x_con_nuestras_excelentes_promociones_de_alojamientos"
>
  Si estás planificando viajar a {{ hotelStatic.city.name }}, reservá ahora tu habitación
  en el alojamiento <strong>{{ hotelStatic.name }}</strong> con nuestras excelentes
  promociones de Alojamientos.
</p>
<p>
  <span i18n="@@seo_detail_el">
    El <strong>{{ hotelStatic.name }}</strong></span
  >
  <span
    *ngIf="hotelStatic.stars > 0"
    i18n="@@seo_detail_esta_calificado_con_x_estrellas_y"
  >
    está calificado con <strong>{{ hotelStatic.stars }} estrellas</strong> y
  </span>
  <span i18n="@@seo_detail_se_encuentra_ubicado_en">
    se encuentra ubicado en <strong>{{ hotelStatic.address }}</strong
    >.</span
  >
</p>
<p
  i18n="
    @@seo_detail_por_que_tenes_que_elegir_hospedarte_en_x_para_tu_viaje_porque_cuenta_una_gran_variedad_de_servicios_y_comodidades_para_que_puedas_disfrutar_de_una_excelente_estadia"
>
  ¿Por qué tenés que elegir hospedarte en <strong>{{ hotelStatic.name }}</strong> para tu
  viaje? Porque cuenta una gran variedad de servicios y comodidades para que puedas
  disfrutar de una excelente estadía.
</p>
<p
  i18n="
    @@seo_detail_reserva_ahora_tu_habitacion_en_x_con_almundo_y_comenza_a_disfrutar_tu_viaje_sin_gastar_de_mas"
>
  Reservá ahora tu habitación en <strong>{{ hotelStatic.name }}</strong> con Almundo y
  comenzá a disfrutar tu viaje sin gastar de más!
</p>
